import { createContext, useCallback, useEffect, useState } from 'react';
import { useEdgesState, useNodesState } from 'reactflow';
import { useSelector } from 'react-redux';
import config from '../../../../../../config/config';
import Fetch from '../../../../../../../core/util/core/Fetch';

export const OrganogramContext = createContext();

const pathAgencyDetails = config.endpoints.backend + 'agencies/getDetailsById';

export const OrganogramProvider = ({ children }) => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;
    const [selectedNode, setSelectedNode] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [nodes, setNodes] = useNodesState([]);
    const [edges, setEdges] = useEdgesState([]);

    const fetchOrganogram = useCallback(async () => {
        const organizationalChart = await Fetch.post(
            `${config.endpoints.backend}portal/getorganizationalchart`,
            { friendly_url }
        );

        if (organizationalChart) {
            const { nodes: fetchedNodes, edges: fetchedEdges } =
                organizationalChart.graph;
            setNodes(fetchedNodes);
            setEdges(fetchedEdges);
        }
    }, [friendly_url]);

    useEffect(() => {
        fetchOrganogram();
    }, [fetchOrganogram]);

    const fetchAgencyDetails = useCallback(
        async (agencyId) => {
            if (!agencyId) return [];
            const agencyDetailsReturn = await Fetch.post(pathAgencyDetails, {
                id: agencyId
            });

            return agencyDetailsReturn;
        },
        [pathAgencyDetails]
    );

    const openModal = async (nodeData) => {
        const agencyId = nodeData.agency;

        const [agencyDetails] = await fetchAgencyDetails(agencyId);

        setSelectedNode({
            ...nodeData,
            ...agencyDetails
        });
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedNode(null);
    };

    return (
        <OrganogramContext.Provider
            value={{
                nodes,
                edges,
                openModal,
                closeModal,
                isModalOpen,
                selectedNode
            }}
        >
            {children}
        </OrganogramContext.Provider>
    );
};
